module.exports = __webpack_public_path__ + "img/china.46867830.svg";